<template>
<div>
  <h4>Выберите Ваш банк:</h4>
  <div id="bankElected">
    <div v-for="(item,index) in bankListComputedElected" :key="index"  class="itemElected"
         v-bind:class="{selected:item.memberId === tinkoffA2C_bankSelected.memberId}"
    >
      <label :for="'bank_'+index">
        <input type="radio" v-model="tinkoffA2C_bankSelected" :value="item" :id="'bank_'+index">
        <img svg-inline :src="item.img">
      </label>
    </div>
  </div>

  <h4>Найти другой банк:</h4>
  <formInput :refs="'finderBankSbp'" :required="false"></formInput>
  <div id="bankName">
    <div v-for="(item,index) in bankListComputed" :key="index"  class="item">
      <label :for="'bank_'+index">
        <input type="radio" v-model="tinkoffA2C_bankSelected" :value="item" :id="'bank_'+index">
        <span>{{item.memberNameRus}}</span>
      </label>
    </div>
  </div>
  <div>
    <button
      v-show="tinkoffA2C_bankSelected.memberId !== ''"
      v-on:click="saveBank"
    >Сохранить</button>
  </div>
</div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "selectSbp",
  data(){
    return {
      bankList:[],
      tinkoffA2C_bankSelected:{
        finderStr:"",
        img:"",
        memberId:"",
        memberName:"",
        memberNameRus:""
      },
      bankIcons: {
        100000000111: require('@/assets/vector/bankIcons/sber.svg'),
        100000000008: require('@/assets/vector/bankIcons/alfa.svg'),
        100000000005: require('@/assets/vector/bankIcons/VTB.svg'),
        100000000010: require('@/assets/vector/bankIcons/PSB.svg'),
        100000000004: require('@/assets/vector/bankIcons/tinkoff.svg'),
        100000000024: require('@/assets/vector/bankIcons/HKB.svg'),
      },
    }
  },
  computed: {
      ...mapState({
        vuexfinderBankSbp: state=>state.Form.sendData.finderBankSbp,
      }),
    bankListComputed() {
      let out = [];
      if (this.vuexfinderBankSbp.length > 0) {
        out = this.bankList.filter((item) => {
          return item.finderStr.indexOf(this.vuexfinderBankSbp.toLowerCase()) >= 0
        });
      }
      return out;
    },
    bankListComputedElected() {
      let outElected = [];
      if (this.bankList.length > 0) {
        for( let i = 0; i<this.bankList.length; i++) {
          if (this.bankIcons[this.bankList[i].memberId] !== undefined) {
            let bankObj = this.bankList[i]
            bankObj['img'] = this.bankIcons[this.bankList[i].memberId]
            outElected.push(bankObj)
          }
        }
      }
      return outElected
    },
  },
  components:{
    formInput:    () => import('@/views/pdlloan/formInput'),
  },
  methods:{
    saveBank(){
      this.$emit('bankSelected', this.tinkoffA2C_bankSelected);
    },
    getTinkoffA2C(){
      this.$axios({
        method: 'post',
        url: process.env.VUE_APP_URL_TINKOF,
        data:{
          action:'get-sbp-members',
          work:true,
        }
      }).then(res=>{
        let tmpBankList = res.data.members.sort((a,b)=>{
          let left = a.memberNameRus.toString().toLowerCase();
          let right = b.memberNameRus.toString().toLowerCase();
          if (left < right) return -1;
          if (left > right) return 1;
          return 0
        });
        for(let i= 0; i < tmpBankList.length; i+=1 ){
          tmpBankList[i]['finderStr'] =  tmpBankList[i].memberName.toLowerCase() + ' ' + tmpBankList[i].memberNameRus.toLowerCase();
        }
        this.bankList = tmpBankList;
      }).catch(res=>{
        console.log(res);
      })
    },
  },
  mounted() {
    this.getTinkoffA2C();
  }
}
</script>

<style scoped>
#payLayout {width: 100%}
.item { border: 1px solid transparent;border-radius: 9px;box-shadow: 0 4px 4px #00000040;transition: 0.3s ease-out;cursor: pointer;margin-bottom: 2.94vw }
.item:hover, .item.selected {background: rgba(67, 172, 52, 0.25);border:1px solid #43AC34}
.item label{display: flex;align-items: center;justify-content: space-around;width: 100%;height: 100%;cursor: pointer;}
.itemElected { border: 1px solid transparent;border-radius: 9px;box-shadow: 0 4px 4px #00000040;transition: 0.3s ease-out;cursor: pointer;margin-bottom: 2.94vw }
.itemElected:hover, .itemElected.selected {background: rgba(67, 172, 52, 0.25);border:1px solid #43AC34}
.itemElected label{display: flex;align-items: center;justify-content: space-around;width: 100%;height: 100%;cursor: pointer;}
.itemElected label img { width: 58.82vw; height: 10.59vw }
.cardView{display: flex;flex-direction: column;align-items: flex-end;justify-content: space-around;height: 100%; width: 62vw}
.cardView img{width: 22.06vw;height: 17.35vw}
#selectorSet, #issetCardLayout,#selectorGet
{display: flex;align-items: center;justify-content: space-between; flex-direction: column;}
#selectorSet .item, #selectorGet .item{width: 90.88vw;height: 47.06vw;}
#selectorSet .itemElected, #selectorGet .itemElected{width: 90.88vw;height: 47.06vw;}
#selectorSet .item svg{width: 61.76vw;height: 35.29vw;outline:none;}
#selectorSet .itemElected svg{width: 61.76vw;height: 35.29vw;outline:none;}
#bankElected {display: flex; flex-wrap: wrap;justify-content: space-between }
#bankName{display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap}
#bankName .item{height:auto;padding: 4.41vw 0}
#bankElected .itemElected{height:auto;padding: 4.41vw 0; width: 100%}
#bankName .item span{width: 76.47vw}
#bankElected .itemElected span{width: 76.47vw}
#bankElected .itemElected input {width: 10vw;}

@media screen and (min-width: 760px) {
  h3 { margin-bottom: 3.23vw }
  #selectorSet, #issetCardLayout,#selectorGet
  {width: 51.61vw; flex-direction: row;}
  #selectorSet .item, #selectorGet .item{width: 24.92vw;height: 12.90vw;}
  #selectorSet .itemElected, #selectorGet .itemElected{width: 24.92vw;height: 12.90vw;}
  #selectorSet .item svg{width: 16.94vw;height: 9.68vw}
  #selectorSet .itemElected svg{width: 16.94vw;height: 9.68vw}


  .item{box-shadow: 0 4px 4px #00000040; margin-bottom: 0.81vw}
  .item:hover, .item.selected {}
  .item label{}

  .itemElected{box-shadow: 0 4px 4px #00000040; margin-bottom: 0.81vw}
  .itemElected:hover, .itemElected.selected {}
  .itemElected label{}
  .itemElected label img { width: 13.13vw;height: 2.54vw; }

  .cardView{ width: 16.27vw }
  .cardView img{width: 75px;height: 59px}

  #bankName{}
  #bankName .item{padding: 15px 0;height: auto}
  #bankElected .itemElected{padding: 15px 0;height: auto;width: 19%}
  #bankName .item span{width: 260px}
  #bankElected .itemElected span{width: 260px}
}

@media screen and (min-width: 1240px) {
  #selectorSet, #issetCardLayout {width: 640px}
  #selectorGet{width: 100%}
  #selectorSet .itemElected, #selectorGet .itemElected{width: 211px;height: 65px;}
  #selectorSet .item, #selectorGet .item{width: 309px;height: 160px;}
  #selectorSet .item svg{width: 210px;height: 120px}
  #selectorSet .itemElected svg{width: 210px;height: 120px}


  .item{box-shadow: 0 4px 4px #00000040; margin-bottom: 10px}
  .item:hover, .item.selected {}
  .item label{}

  .itemElected{box-shadow: 0 4px 4px #00000040; margin-bottom: 10px}
  .itemElected:hover, .itemElected.selected {}
  .itemElected label{}
  .itemElected label img { width: 150px; height: 60px }
  .itemElected:nth-child(1) label img { height: 31px; padding-top: 10px }
  .itemElected:nth-child(2) label img { height: 31px; padding-bottom: 4px }
  .itemElected:nth-child(3) label img { height: 31px }

  .cardView{ width: 196px }
  .cardView img{width: 75px;height: 59px}

  #bankName{}
  #bankName .item{padding: 15px 0;height: auto}
  #bankElected .itemElected{padding: 15px 0; }
  #bankName .item span{width: 260px}
  #bankElected .itemElected span{width: 260px}
}
</style>